import { createStore } from 'vuex';

// 尝试从本地存储中恢复状态


// 尝试从本地存储中恢复状态

export default createStore({

    state: {
        womenItems: [],
        menItems: [],
        childItems: [],
        accessory: [],
        photography: [],
        returnWay: [],
        formData: {
            name: "",
            num: "",
            orderStore: "和装小町 花音",
            email: "",
            phone: "",
        },

    },
    mutations: {
        updateItemSelection(state, { category, itemId, selected }) {
            const item = state[category].find(item => item.id === itemId);
            if (item) {
                item.selected = selected;
                item.num = selected ? 1 : 0;

                // 更新本地存储中的套餐项点击状态
                const itemState = JSON.parse(sessionStorage.getItem('itemState')) || {};
                if (!itemState[category]) {
                    itemState[category] = [];
                }
                if (selected) {
                    if (!itemState[category].includes(itemId)) {
                        itemState[category].push(itemId);
                    }
                } else {
                    const index = itemState[category].indexOf(itemId);
                    if (index !== -1) {
                        itemState[category].splice(index, 1);
                    }
                }
                sessionStorage.setItem('itemState', JSON.stringify(itemState));
            }
        },

        updateReturnWay(state, returnWay) {
            state.returnWay = returnWay;
            sessionStorage.setItem('storeState', JSON.stringify(state));
        },
        SET_SELECTED_COUNT(state, count) {
            state.selectedCount = count;
            sessionStorage.setItem('storeState', JSON.stringify(state));
        },
        setSelectedDate(state, date) {
            state.selectedDate = date;
            sessionStorage.setItem('storeState', JSON.stringify(state));
        },
        setSelectedCount(state, count) {
            state.selectedCount = count;
            sessionStorage.setItem('storeState', JSON.stringify(state));
        },
        updatePhotography(state, photographys) {
            state.photographys = photographys;
            sessionStorage.setItem('storeState', JSON.stringify(state));
        },
        updateSelectedItems(state, selectedItems) {
            state.selectedItems = selectedItems;
            sessionStorage.setItem('storeState', JSON.stringify(state));
        },
        updateFormData(state, formData) {
            state.formData = { ...state.formData, ...formData };
            sessionStorage.setItem('storeState', JSON.stringify(state));
        },
        setSelectedAppointmentTime(state, time) {
            state.selectedAppointmentTime = time;
            sessionStorage.setItem('storeState', JSON.stringify(state));
        },


    },

    actions: {
        updateSelectedItems({ commit }, selectedItems) {
            // 提交 mutation 更新选中的套餐项目
            commit('updateSelectedItems', selectedItems);
        },
        updatePhotography({ commit }, photographys) {
            // 提交 mutation 更新选中的套餐项目
            commit('updatePhotography', photographys);
        },
        // 定义 actions 来触发 mutations
        updateSelectedDate({ commit }, date) {
            commit('setSelectedDate', date);
        },
        updateSelectedCount({ commit }, count) {
            commit('setSelectedCount', count);
        },
        setSelectedCount({ commit }, count) {
            commit('SET_SELECTED_COUNT', count)
        },

    },
    getters: {
        getReturnWay(state) {
            return state.returnWay;
        },
        // 定义 getters 来获取状态数据
        getSelectedDate(state) {
            return state.selectedDate;
        },
        getSelectedCount(state) {
            return state.selectedCount;
        },
        // 定义 getters 来获取状态数据
        getSelectedItems(state) {
            return state.selectedItems;
        },
        getphotographys(state) {
            return state.photographys;
        },
        getFormData(state) {
            return state.formData;
        },
        selectedAppointmentTime(state) {
            return state.selectedAppointmentTime;
        },
    },

    plugins: [
        (store) => {
            // 尝试从本地存储中恢复状态
            const storeState = sessionStorage.getItem('storeState');
            if (storeState) {
                store.replaceState(JSON.parse(storeState));
            }

            // 监听mutation，保存状态到本地存储
            store.subscribe((mutation, state) => {
                sessionStorage.setItem('storeState', JSON.stringify(state));
            });
        }
    ],
});
